export default __webpack_public_path__ + "static/media/phone-icon.1988ecd0.png";